<template>
  <div>
    <slot />
  </div>
</template>
<style scoped lang="scss">
@import "@/designSystem/style/variables/_spacing.scss";
@import "@/designSystem/style/variables/_colors.scss";

@import "@/designSystem/style/variables/_coefficient.scss";

$scrollable-content-height: 9.25rem * $coef;

div {
  overflow-y: auto;
  width: 100%;
  padding: $spacer3;
  border-radius: $spacer4;
  background-color: $lighter;
  height: $scrollable-content-height;
}
</style>
